import { QueryKey, useMutation } from '@tanstack/react-query';
import { User } from 'api/types';
import { AxiosError } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

export function useUnblockUserMutation(userId: number) {
  const axios = useAxios();
  return useMutation<User, AxiosError<{ message: string }>>({
    mutationKey: getKey(userId),
    mutationFn: async () => axios.put(`${config.apiBaseUrl}/op/v1/users/${userId}/unblock`),
  });
}

export function getKey(userId: number) {
  return ['UnblockUser', userId] as const satisfies QueryKey;
}
